import { render } from "./MaterialAvatar.vue?vue&type=template&id=60c818da&scoped=true"
import script from "./MaterialAvatar.vue?vue&type=script&lang=js"
export * from "./MaterialAvatar.vue?vue&type=script&lang=js"

import "./MaterialAvatar.vue?vue&type=style&index=0&id=60c818da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c818da"]])

export default __exports__